
const WEATHER = {

  // 天気アイコンのベースURL
  iconBaseURL: process.env.REACT_APP_MAPION_WEATHER_ICON_BASE_URL,
  // 天気アイコンの拡張子
  iconExt: '.gif',

  // デフォルトの天気コード（不明時）
  defaultWeatherCode: '999',
  // 温度が不明な場合の表示ラベル
  temperatureUnknownLabel: '--',
  // 温度の単位記号
  degreeSymbol: '°C',

  // 地域コードのゼロパディング桁数
  prefCodePadding: 2,
  cityCodePadding: 5,
};

export default WEATHER;
